<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" @click="$router.push('/rentManage/add')">新增</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">
        <el-form-item prop="userId" label="客户名称">
          <el-select v-model="searchForm.userId" clearable placeholder="请选择客户名称">
            <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="specId" label="品种规格">
          <el-select v-model="searchForm.specId" clearable placeholder="请选择品种规格">
            <el-option v-for="(item, index) of specList" :value="item.specId" :label="item.specName"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联仓库" prop="ygId">
          <el-select v-model="searchForm.ygId" clearable placeholder="请选择关联仓库">
            <el-option v-for="(item, index) of ygList" :value="item.warehouseId" :label="item.warehouseName" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="120" label="客户名称" prop="userName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="存油记录" prop="storageId"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="品种规格" prop="specName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="存油数量" prop="quantity"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="关联仓库" prop="ygCode"></el-table-column>
        <el-table-column show-overflow-tooltip label="合同金额(元)" min-width="120" prop="contractAmount"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="130" label="开始计价日期" prop="startDate"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="150" label="租赁到期时间 " prop="endDate"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="150" label="每日租金单价(元)" prop="dailyRent"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="150" label="每日最低收费(元)" prop="minimumPrice"></el-table-column>
        <!-- 新增绩效系数列 -->
<!--        <el-table-column show-overflow-tooltip min-width="120" label="绩效系数" prop="jxRatio"></el-table-column>-->
        <el-table-column show-overflow-tooltip min-width="160" label="创建时间" prop="ctime"></el-table-column>

        <el-table-column fixed="right" label="操作" width="200">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.push('/rentManage/detail?storageId=' + row.storageId)">详情</el-button>
            <el-button type="text" @click="$router.push('/rentManage/edit?storageId=' + row.storageId)">编辑</el-button>
            <el-button type="text" style="color:red" @click="deleteRow(row.storageId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
                     @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'RentManage',
  data() {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        ygId: null,
        specId: null,
        userId: null,
        storageId: null
      },

      ygList: [],
      userList: [],
      storeList: [],
      specList: []
    }
  },
  created() {
    this.loadDict()
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.rentManage.selectYgnCustRentByPage, {
        params: {
          page: this.page,
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    loadDict() {
      this.$axios.get(this.$apis.prodManage.selectLyWarehouseByPage).then(res => {
        this.ygList = res.list.map(item => {
          return {
            warehouseId: item.warehouseId,
            warehouseName: item.warehouseName
          }
        })
      })

      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '2'
      }).then(res => {
        this.userList = res.list || []
      })

      this.$axios
        .get(this.$apis.grainSpecifications.selectYxOilSpecByList)
        .then(res => {
          this.specList = res.list || []
        })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    resetForm() {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        ygId: null,
        specId: null,
        userId: null,
        storageId: null
      }
      this.onSearch()
    },

    deleteRow(storageId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.rentManage.deleteDataYgnCustRent, {
          storageId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'></style>
